import { render } from "./Notifications.vue?vue&type=template&id=f7251b72&scoped=true"
import script from "./Notifications.vue?vue&type=script&lang=js"
export * from "./Notifications.vue?vue&type=script&lang=js"

import "./Notifications.vue?vue&type=style&index=0&id=f7251b72&scoped=true&lang=css"
import "./Notifications.vue?vue&type=style&index=1&id=f7251b72&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7251b72"]])

export default __exports__